import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'app/lib/hooks';
import { Button, ButtonSize } from 'app/components/core/Button';
import { Input } from 'app/components/core/Input';
import {
    Dialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalActions
} from 'app/components/core/Modal';
import { Form, Field, Submit, Yup } from 'app/components/core/Form';
import { FieldLayout } from 'app/components/core/FieldLayout';
import { AssetNameSchema } from 'app/lib/schemas';
import {
    doCreateProject,
    selectIsCreatingProject,
    selectIsCreateProjectDialogOpen,
    selectObjectToImportToCreatedProject,
    selectIsAddingExplorations
} from 'app/store/projects';

const schema = Yup.object({
    name: AssetNameSchema
});

const initialValues = {
    name: ''
};

export function LegacyCreateProjectDialog({ onClose }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const isDialogOpen = useSelector(selectIsCreateProjectDialogOpen);
    const isCreatingProject = useSelector(selectIsCreatingProject);
    const addressToImport = useSelector(selectObjectToImportToCreatedProject);
    const isAddingExplorations = useSelector(selectIsAddingExplorations);

    const handleSubmit = useCallback(
        ({ name }) => {
            dispatch(doCreateProject({ name, addressToImport, isAddingExplorations }));
        },
        [dispatch, addressToImport, isAddingExplorations]
    );

    if (!isDialogOpen) {
        return null;
    }

    return (
        <Dialog width={350} onClose={onClose}>
            <ModalHeader>
                <ModalTitle>{t('components:CreateProjectDialog.title')}</ModalTitle>
            </ModalHeader>
            <ModalBody>
                <Form
                    schema={schema}
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    isSubmitting={isCreatingProject}
                    allowTransformation>
                    <FieldLayout>
                        <Field
                            component={Input}
                            id="create-space-name"
                            name="name"
                            label={t('components:CreateProjectDialog.inputLabel')}
                            autoFocus
                        />
                    </FieldLayout>
                    <ModalActions>
                        <Button onClick={onClose} size={ButtonSize.MEDIUM}>
                            {t('common:cancel')}
                        </Button>
                        <Submit size={ButtonSize.MEDIUM}>{t('common:ok')}</Submit>
                    </ModalActions>
                </Form>
            </ModalBody>
        </Dialog>
    );
}
